import { useState } from "react";
import { TextInput, Space, Button, Switch } from "@mantine/core";

import { useUser } from "../../../hooks/useUser";

import { STYLE } from "@jasper/shared";

const AddNewMemberToGroupModal = ({
  group_id,
  closeModal,
  refetch,
}: {
  group_id: string;
  closeModal: () => void;
  refetch: () => void;
}) => {
  const [inputEmail, setInputEmail] = useState<string>("");
  const [isUserManager, setIsUserManager] = useState<boolean>(false);

  const { updateUser } = useUser();

  const onSubmit = async () => {
    const userUpdated = await updateUser({
      variables: {
        where: {
          email: inputEmail,
        },
        data: {
          userGroup: {
            connect: {
              id: group_id,
            },
          },
          isManager: {
            set: isUserManager,
          },
        },
      },
    });
    if (userUpdated) {
      refetch();
      closeModal();
    }
  };

  return (
    <>
      <TextInput
        label="Email of user to add"
        value={inputEmail}
        onChange={e => setInputEmail(e.target.value)}
      />
      <Space h="md" />
      <Switch
        label="Will this user be a master account ?"
        description="This action will be effective in all group where this user is a member."
        checked={isUserManager}
        onChange={() => setIsUserManager(!isUserManager)}
      />
      <Space h="md" />
      <div style={{ textAlign: "center" }}>
        <Button style={{ backgroundColor: STYLE.primary }} onClick={onSubmit}>
          Save
        </Button>
      </div>
    </>
  );
};

export default AddNewMemberToGroupModal;
